const Footer = () => {
  return (
    <footer>
      <p>© 2022, ✨Developed by <a href="http://jencodes.com" target="_blank" rel="noreferrer">Jen Luu</a> @ Juno College of Technology</p>
    </footer>
  )
}

export default Footer;